import React from "react";

import { AUTOPILOT_COLORS, autopilotInsetCardStyle } from "../autopilot/styles";

/**
 * Container PADRÃO do produto (theme-aware). Use SEMPRE este componente para as
 * "caixas" das telas, em vez de cravar background/borda na mão. O fundo e a
 * borda vêm dos tokens `--everlog-*` (AUTOPILOT_COLORS), então acompanham o
 * tema claro/escuro automaticamente.
 *
 * - `variant="section"` (padrão): container interno (surface-elevated). É o que
 *   as telas de Auditoria de CTe/Fatura usam.
 * - `variant="field"`: caixa mais "funda" (surface-field), p/ métricas/campos
 *   dentro de um SectionCard.
 *
 * Props: eyebrow, title, description, action (canto sup. direito), children, style.
 */
export const sectionCardStyle = { ...autopilotInsetCardStyle, padding: "0.95rem 1rem" };
export const fieldCardStyle = {
  ...autopilotInsetCardStyle,
  padding: "0.85rem 0.95rem",
  background: "var(--everlog-card-surface-field)",
};

const eyebrowStyle = {
  color: AUTOPILOT_COLORS.accent,
  fontSize: "0.74rem",
  fontWeight: 700,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  marginBottom: "0.35rem",
};
const titleStyle = {
  color: AUTOPILOT_COLORS.title,
  fontSize: "0.96rem",
  fontWeight: 700,
  marginBottom: "0.25rem",
};
const descriptionStyle = {
  color: AUTOPILOT_COLORS.muted,
  fontSize: "0.82rem",
  lineHeight: 1.5,
  marginBottom: 0,
};

export default function SectionCard({
  eyebrow,
  title,
  description,
  action,
  children,
  variant = "section",
  style,
}) {
  const base = variant === "field" ? fieldCardStyle : sectionCardStyle;
  const hasHeader = eyebrow || title || description || action;

  return (
    <div style={{ ...base, ...style }}>
      {hasHeader && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "0.75rem",
            alignItems: "flex-start",
            marginBottom: children ? "0.85rem" : 0,
          }}
        >
          <div style={{ minWidth: 0 }}>
            {eyebrow ? <div style={eyebrowStyle}>{eyebrow}</div> : null}
            {title ? <div style={titleStyle}>{title}</div> : null}
            {description ? <div style={{ ...descriptionStyle, marginBottom: 0 }}>{description}</div> : null}
          </div>
          {action ? <div style={{ flexShrink: 0 }}>{action}</div> : null}
        </div>
      )}
      {children}
    </div>
  );
}
